<app-webpage-analytics></app-webpage-analytics>

<div class="flex">
    <div class="ontario-row recordContainer">

        <app-breadcrumbs></app-breadcrumbs>

        <div class="divider">
            <h1> {{ title }} </h1>
        </div>

        <app-copy-to-clipboard [index]="databaseIndex" [fileNumber]="publicationNumber"></app-copy-to-clipboard>


        <ng-template [ngTemplateOutlet]="detailsTable"></ng-template>

        <div class="ontario-accordions__container">
            <div class="ontario-accordion__controls">
                <button class="ontario-accordion__button--expand-all" aria-expanded="false">
                    <span class="ontario-accordion--expand-open-all">{{ 'expand.all' | translate | async }}</span>
                    <span class="ontario-accordion--expand-close-all">{{ 'collapse.all' | translate | async }}</span>
                </button>
            </div>
            <div *ngIf="go_files" class="ontario-accordion" id="accordion-1">
                <button class="ontario-accordion__button" id="accordion-button-id-1" aria-controls="accordion-content-1"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'downloads' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-1" aria-labelledby="accordion-button-id-1" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="downloadsTable"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-2">
                <button class="ontario-accordion__button" id="accordion-button-id-2" aria-controls="accordion-content-2"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'geographic.data' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-2" aria-labelledby="accordion-button-id-2" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="publicationGeographicDataTable"></ng-template>
                </section>
            </div>
            <div *ngIf="associatedPublications" class="ontario-accordion" id="accordion-3">
                <button class="ontario-accordion__button" id="accordion-button-id-3" aria-controls="accordion-content-3"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'associated.publications' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-3" aria-labelledby="accordion-button-id-3" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="associatedPublicationsTable"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-4">
                <button class="ontario-accordion__button" id="accordion-button-id-4" aria-controls="accordion-content-4"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>{{ 'metadata' | translate | async }}</h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-4" aria-labelledby="accordion-button-id-4" aria-hidden="true" data-toggle="ontario-expander-content">
                    <ng-template [ngTemplateOutlet]="metadataTable"></ng-template>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-5">
                <button class="ontario-accordion__button" id="accordion-button-id-5" aria-controls="accordion-content-5"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'report.an.error' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-5" aria-labelledby="accordion-button-id-5" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'publication.report.an.error.text' | translate | async }}">
                            {{ 'publication.report.an.error.text' | translate | async }}
                    </div>
                </section>
            </div>
            <div class="ontario-accordion" id="accordion-6">
                <button class="ontario-accordion__button" id="accordion-button-id-6" aria-controls="accordion-content-6"
                    aria-expanded="false" data-toggle="ontario-collapse">
                    <span class="ontario-accordion__button-icon--close">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-up"></use>
                        </svg>
                    </span>
                    <span class="ontario-accordion__button-icon--open">
                        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
                            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-chevron-down"></use>
                        </svg>
                    </span>
                    <h2>
                        {{ 'terms.of.use' | translate | async }}
                    </h2>
                </button>
                <section class="ontario-accordion__content" id="accordion-content-6" aria-labelledby="accordion-button-id-6" aria-hidden="true" data-toggle="ontario-expander-content">
                    <div>
                        <p innerHTML="{{ 'terms.of.use.link' | translate | async }}">
                            {{ 'terms.of.use.link' | translate | async }}
                        </p>
                    </div>
                </section>
            </div>
        </div>

        <div class="mt-4 divider contactInformationContainer">
            <div class="flex mb-4 ">
                <h3 class="contactInformationTitle">
                    {{ 'contact.information' | translate | async }}
                </h3>   
                <p class="contactInformationValue" innerHTML="{{ 'publication.contact.text' | translate | async }}">
                    {{ 'publication.contact.text' | translate | async }}
                </p> 
            </div>
        </div>

        <ng-template #detailsTable>
            <div>
                <div>
                    <h2 class="mt-3 mb-3">{{ 'publication.details' | translate | async }}</h2>
                </div>
                <div class="detailsContainer">
                    <div class="flex">
                        <div class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'publication.number' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ publicationNumber | highlight : this.searchTerms }}">
                                {{ publicationNumber | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="publicationYear" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'publication year' | translate | async }}:</p>
                            <p class="recordValue">
                                {{ publicationYear }}
                            </p>
                        </div>
                        <div *ngIf="contributors.length > 0" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'author' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ contributors | commaSeparatedPipe:'contributor' | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ contributors | commaSeparatedPipe:'contributor' | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="series" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'series' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ series | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ series | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="scale" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'scale' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ scale | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ scale | notApplicablePipe | async | highlight : this.searchTerms }}
                            </p>
                        </div>
                        <div *ngIf="price" class="flex mb-0">
                            <p class="metadataAttributeTitle font-weight--bold">{{ 'hard.copy.price' | translate | async }}:</p>
                            <p class="recordValue" innerHTML="{{ price | currency | notApplicablePipe | async | highlight : this.searchTerms }}">
                                {{ price | currency | notApplicablePipe | async }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #downloadsTable>
            <div>
                <div>
                    <div class="ontario-table-container">
                        <div class="ontario-table-div mb-0">
                            <table class="flex-child" tabindex="0">
                                <thead>
                                    <tr>
                                        <th scope="col">{{ 'name' | translate | async }}</th>
                                        <th scope="col">{{ 'size' | translate | async }}</th>
                                        <th scope="col">{{ 'date.last.modified' | translate | async }}</th>
                                        <th scope="col">{{ 'type' | translate | async }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let file of record.go_file">
                                        <td scope="row">
                                            <ng-container *ngIf="file.url && file.url != ''; else titleOnly">
                                                <a target="_blank" 
                                                    innerHTML="{{ file.name | highlight : this.searchTerms }}"
                                                    href="{{this.downloadsAZStorage}}/{{file.url}}">
                                                    {{ file.name | highlight : this.searchTerms }}
                                                </a>                                            
                                            </ng-container>
                                            <ng-template #titleOnly>
                                                <p innerHTML="{{ file.name | highlight : this.searchTerms }}">
                                                    {{ file.name | highlight : this.searchTerms }}
                                                </p>
                                            </ng-template>
                                        </td>
                                        <td scope="row" innerHTML="{{ file.file_size | number:'1.0':'en-US' | notApplicablePipe | async | highlight : this.searchTerms }} {{ 'kilobyte' | translate | async }}">
                                            {{ file.file_size | number:'1.0':'en-US' | notApplicablePipe | async | highlight : this.searchTerms }} {{ 'kilobyte' | translate | async }}
                                        </td>
                                        <td scope="row" innerHTML="{{ file.updated_at | date: 'YYYY-MM-dd' | notApplicablePipe | async }}">
                                            {{ file.updated_at | date: 'YYYY-MM-dd' | notApplicablePipe | async }}
                                        </td>
                                        <td scope="row" innerHTML="{{ file.mime_type | uppercase | notApplicablePipe | async | highlight : this.searchTerms }}">
                                            {{ file.mime_type | uppercase | notApplicablePipe | async | highlight : this.searchTerms }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #publicationGeographicDataTable>
            <div>
                <div class="detailsContainer">
                    <div class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'township.area' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ townships | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ townships | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">{{ 'nts' | translate | async }}:</p>
                        <p class="recordValue" innerHTML="{{ nts | commaSeparatedPipe:'area' | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ nts | commaSeparatedPipe:'area' | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                    <div class="flex mb-0">
                        <p class="metadataAttributeTitle font-weight--bold">
                            {{ 'resident.geologist.district' | translate | async }}:
                        </p>
                        <p class="recordValue" innerHTML="{{ rgpDistrict | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                            {{ rgpDistrict | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
                        </p>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #associatedPublicationsTable>
            <div class="ontario-table-container">
                <div class="ontario-table-div mb-0">
                    <table class="flex-child" tabindex="0">
                        <thead>
                            <tr>
                                <th scope="col">{{ 'publication.number' | translate | async }}</th>
                                <th scope="col">{{ 'title' | translate | async }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let associated_publication of record.associated_publications">
                                <a target="_blank" 
                                    innerHTML="{{ associated_publication.publ_num | notApplicablePipe | async | highlight : this.searchTerms }}"
                                    href="{{this.publicationPersistentLink}}{{associated_publication.publ_num}}">
                                    {{ associated_publication.publ_num | notApplicablePipe | async | highlight : this.searchTerms }}
                                </a>    
                                <td scope="row" innerHTML="{{ associated_publication.title | notApplicablePipe | async | highlight : this.searchTerms }}">
                                    {{ associated_publication.title | notApplicablePipe | async | highlight : this.searchTerms }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-template>

        <ng-template #metadataTable>
            <div class="detailsContainer">
                <div class="flex mb-0">
                    <p class="font-weight--bold">{{ 'topic' | translate | async }}:</p>
                    <p class="ml-1" innerHTML="{{ topic | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}">
                        {{ topic | commaSeparatedPipe:'name' | notApplicablePipe | async | highlight : this.searchTerms }}
                    </p>
                </div>
                <div class="flex mb-0">
                    <p class="font-weight--bold">{{ 'abstract' | translate | async }}:</p>
                    <p class="ml-1" innerHTML="{{ abstract | notApplicablePipe | async | highlight : this.searchTerms }}">
                        {{ abstract | notApplicablePipe | async | highlight : this.searchTerms }}
                    </p>
                </div>
                <div class="flex mb-0">
                    <p class="font-weight--bold">{{ 'purpose' | translate | async }}:</p>
                    <p class="ml-1" innerHTML="{{ purpose | notApplicablePipe | async | highlight : this.searchTerms }}">
                        {{ purpose | notApplicablePipe | async | highlight : this.searchTerms }}
                    </p>
                </div>
                <div class="flex mb-0">
                    <p class="font-weight--bold">{{ 'keywords' | translate | async }}:</p>
                    <p class="ml-1" innerHTML="{{ keywords | notApplicablePipe | async | highlight : this.searchTerms }}">
                        {{ keywords | notApplicablePipe | async | highlight : this.searchTerms }}
                    </p>
                </div>
            </div>
        </ng-template>

    </div>
    
    <!-- Scroll Button -->
    <button onClick="scrollToTop()" class="ontario-back-to-top--default">
        <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary"
            viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
            <use href="#ontario-icon-arrow-up"></use>
        </svg>
        {{ 'top' | translate | async }}
    </button>
    
</div>